var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tooltip"},[_c('span',[_vm._v(_vm._s(_vm.label))]),_c('el-tooltip',{attrs:{"placement":"top"},scopedSlots:_vm._u([{key:"content",fn:function(){return [_vm._t("content")]},proxy:true}],null,true)},[_c('i',{staticClass:"iconfont icon-a-help-circle-obangzhu-xian"})]),_c('div',{class:`bg i-home-commission-${_vm.className}`})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }